module.exports = __webpack_public_path__ + "img/topicDomesticChemicals.5c84c785.svg";